<template>
  <section class="w-full mb-4 wrapper-bar-chart" @click="optionsUser = null">
    <div class="flex flex-col justify-between py-6 border-b">
      <div class="text-sm text-start px-4">
        <span class="mr-2 cursor-pointer" :class="selectedFilter === 'all' ? 'text-blue-500' : 'text-gray-500'"
          @click="$emit('on-selected-filter', 'all')">
          All Users
        </span>
        <span class="mr-2 cursor-pointer" :class="selectedFilter === 'active' ? 'text-blue-500' : 'text-gray-500'
          " @click="$emit('on-selected-filter', 'active')">
          Active
        </span>
        <span class="mr-2 cursor-pointer" :class="selectedFilter === 'inactive' ? 'text-blue-500' : 'text-gray-500'
          " @click="$emit('on-selected-filter', 'inactive')">
          Inactive
        </span>
      </div>
    </div>
    <section class="w-full custom-scrollbar">
      <table class="w-full pb-4 min-w-max">
        <tbody v-if="!isLoading && !loading.users">
          <tr class="border-b h-max" v-for="(user, index) in users" :key="index">
            <td class="p-4 text-sm">
              <div class="flex flex-row items-center gap-x-2">
                <div class="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-zinc-400">
                  <h2 class="text-white text-md">
                    {{ avatarEmployee(user.name) }}
                  </h2>
                </div>
                <div class="flex flex-col">
                  <p class="text-sm text-blue-500">
                    {{ user.name }}
                  </p>
                  <p class="text-sm text-gray-400">
                    {{ user.email }}
                  </p>
                </div>
              </div>
            </td>
            <!-- <td class="p-4 text-sm">{{ user.role }}</td> -->
            <td class="text-sm">
              <div :class="user.status ? 'bg-green-500' : 'bg-red-500'"
                class="rounded-full text-center text-white py-1 px-3 w-24">
                {{ user.status ? "Active" : "Inactive" }}
              </div>
            </td>
            <td class="p-4 w-8 relative text-right">
              <Button class="p-3 shadow-none rotate-90 hover:bg-blue-100 text-primary rounded-full"
                @click.stop="optionsUser === index ? optionsUser = null : optionsUser = index">
                <font-awesome-icon icon="fa-ellipsis" />
              </Button>
              <div
                class="action_user text-left absolute -top-full right-16 rounded-md bg-white shadow-md w-52 md:w-max md:h-max"
                v-if="optionsUser === index">
                <ul class="text-sm">
                  <li @click="openEditModal(user)">
                    Edit
                  </li>
                  <li v-if="user.status" @click.stop="handleChangeUserStatus(); optionsUser = null">
                    Deactivate
                  </li>
                  <li v-else="user.status" @click.stop="handleChangeUserStatus(); optionsUser = null">
                    Activate
                  </li>
                  <li @click="openMngModal(user)">
                    Manage Role
                  </li>
                  <li @click="openDelModal(user)">
                    Remove From Users
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td>Loading ...</td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="!isLoading && users.length"
        :current="meta && meta.currentPage ? meta.currentPage : page"
        :total="meta && meta.total ? meta.total : users.length"
        :per-page="limit"
        @page-changed="pageChanged"
      />
    </section>
  </section>
</template>

<script>
import Pagination from "@ocrv/vue-tailwind-pagination";
import Button from "../Button.vue";
import "@ocrv/vue-tailwind-pagination/styles";
import { SwitchUserStatus } from "@/actions/users-and-roles";

export default {
  name: "UsersList",
  components: {
    Pagination,
    Button,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
    meta: {
      type: Object,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    selectedFilter: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      optionsUser: null,
      userid: null,
      loading: {
        users: false,
      },
    };
  },
  methods: {
    avatarEmployee(employeeFullname) {
      if (employeeFullname) {
        return (
          employeeFullname.substr(0, 1) +
          employeeFullname.substr(employeeFullname.indexOf(" ") + 1, 1)
        );
      }
    },
    async handleChangeUserStatus() {
      this.loading.users = true;
      const uid = this.users[this.optionsUser]?._id;
      const ustatus = this.users[this.optionsUser]?.status;
      console.log(uid);
      const response = await SwitchUserStatus({
        userId: uid,
        status: !ustatus,
      });
      if (response?.status === 401) {
        this.$router.push("/login");
        this.toast.error(response?.data?.message);
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.$emit("on-selected-filter", this.selectedFilter);
      this.loading.users = false;
    },
    openEditModal(user) {
      console.log(user);
      this.$emit("on-showModal", { modal: { edit: true, manage: false, delete: false }, user: user });
    },
    openMngModal(user) {
      this.$emit("on-showModal", {
        modal: { edit: false, manage: true, delete: false },
        user,
      });
    },
    openDelModal(user) {
      this.$emit("on-showModal", {
        modal: { edit: false, manage: false, delete: true },
        user,
      });
    },
    pageChanged(event) {
      this.$emit("on-pagination", event);
    },
  },
};
</script>

<style scoped>
.action_user ul li {
  padding: 10px 16px;
  cursor: pointer;
  color: rgb(192, 192, 192);
}

.action_user ul li:hover {
  color: rgb(71, 166, 255);
}
</style>
